import { Link } from "react-router-dom";
import { assetUrl } from "../../utils/api";
import { formatFileSize } from "../../api/ebookApi";
import EbookDownloadButton from "./EbookDownloadButton";

export default function EbookCard({ ebook, userId, compact = false }) {
  return (
    <article className="bg-white rounded-2xl shadow hover:shadow-md border border-transparent hover:border-pink-100 transition overflow-hidden flex flex-col">
      <Link to={`/ebooks/${ebook.id}`} className="block">
        {ebook.cover_path ? (
          <img
            src={assetUrl(ebook.cover_path)}
            alt={ebook.title}
            className={`w-full object-cover ${compact ? "h-40" : "h-52"}`}
          />
        ) : (
          <div
            className={`w-full bg-gradient-to-br from-indigo-100 via-pink-100 to-amber-100 flex items-center justify-center ${
              compact ? "h-40 text-4xl" : "h-52 text-5xl"
            }`}
          >
            📚
          </div>
        )}
      </Link>

      <div className={`flex-1 flex flex-col ${compact ? "p-4 space-y-2" : "p-5 space-y-3"}`}>
        <Link to={`/ebooks/${ebook.id}`} className="space-y-1">
          {ebook.is_featured ? (
            <span className="text-xs text-pink-500 font-medium">推荐</span>
          ) : null}
          <h3 className={`font-bold text-gray-800 line-clamp-2 ${compact ? "text-base" : "text-lg"}`}>
            {ebook.title}
          </h3>
          <p className="text-sm text-gray-500">
            作者：{ebook.author || "未知"}
          </p>
          {!compact ? (
            <p className="text-xs text-gray-400">
              {ebook.category_name || "未分类"}
              {ebook.file_type ? ` · ${String(ebook.file_type).toUpperCase()}` : ""}
              {ebook.file_size ? ` · ${formatFileSize(ebook.file_size)}` : ""}
            </p>
          ) : null}
        </Link>

        <p className="text-xs text-emerald-600 font-medium">🟢 会员免费下载</p>

        <div className="mt-auto flex flex-wrap gap-2">
          <Link
            to={`/ebooks/${ebook.id}`}
            className="px-4 py-2 rounded-full border border-gray-200 text-sm text-gray-600 hover:bg-gray-50"
          >
            查看详情
          </Link>
          {!compact ? (
            userId ? (
              <EbookDownloadButton ebook={ebook} userId={userId} size="sm" />
            ) : (
              <Link
                to="/login"
                className="px-4 py-2 rounded-full bg-gray-100 text-sm text-gray-600 hover:bg-gray-200"
              >
                🔒 登录后下载
              </Link>
            )
          ) : null}
        </div>
      </div>
    </article>
  );
}
